import { createContext, useContext } from 'react'
import type { StepId } from '../../model/delivery'
import type { WizardCtx } from '../../pages/delivery/context'
import type { HeaderFarmer } from '../kit'
import { cropName, tr, rosterShort } from '../text'

/** The six steps the V1 boards count (moisture keeps its place even when skipped). */
export const V1_STEP_NO: Record<StepId, number> = {
  details: 1,
  check: 1,
  moisture: 2,
  price: 3,
  tag: 3,
  sample: 4,
  slip: 5,
  close: 6,
}

export interface V1Ctx extends WizardCtx {
  /** Records not yet sent (header clock). */
  pending: number
  /** Leave the delivery screens (the draft stays). */
  exit: () => void
  busy: boolean
  commit: () => Promise<void>
  /** Cancel now (V1: no tag scans) — farmer left, or dry at home. */
  cancel: (reason: 'WALK_AWAY' | 'DIVERTED_TO_DRY') => Promise<void>
  /** Tags and seals on the other farmers open on this phone (code → farmer's name). */
  otherCodes: ReadonlyMap<string, string>
}

export const V1Context = createContext<V1Ctx | null>(null)

export function useV1(): V1Ctx {
  const c = useContext(V1Context)
  if (!c) throw new Error('useV1 outside the V1 delivery')
  return c
}

/** The farmer at the top of every delivery screen: "नं. 112 · मूंग". */
export function useHeaderFarmer(): HeaderFarmer {
  const { d, roster } = useV1()
  const crop = cropName(roster.config.crops, d.crop_id)
  return {
    name: d.farmer.name,
    line: crop
      ? tr('gate.v1.farmerLine', { no: rosterShort(d.farmer.roster_no), crop })
      : tr('gate.v1.farmerNo', { no: rosterShort(d.farmer.roster_no) }),
    photo: d.farmer.photo_url,
  }
}
